import usePersistedState from "./usePersistedState";

const USER_SETTING_PREFIX = "userSetting:";

// thin wrapper so all user settings share a single storage namespace
const useUserSetting = ({ key, defaultValue }) => {
   return usePersistedState({ key: `${USER_SETTING_PREFIX}${key}`, defaultValue });
};

export default useUserSetting;
